import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  }
};

const enhance = compose();

const GochiTableHead = enhance(
  ({ order, orderBy, onRequestSort, isFullInfo, isFukuoka }) => {
    return (
      <TableHead>
        <TableRow>
          <TableCell sortDirection={orderBy === 'shopName' ? order : false}>
            <TableSortLabel
              active={orderBy === 'shopName'}
              direction={order}
              onClick={() => {
                onRequestSort('shopName');
              }}
            >
              {isFukuoka ? '教室名' : '店舗名'}
            </TableSortLabel>
          </TableCell>
          {!isFukuoka && (
            <TableCell
              sortDirection={orderBy === 'amountWhenBuy' ? order : false}
            >
              <TableSortLabel
                active={orderBy === 'amountWhenBuy'}
                direction={order}
                onClick={() => {
                  onRequestSort('amountWhenBuy');
                }}
              >
                ごち購入額
              </TableSortLabel>
            </TableCell>
          )}
          <TableCell
            sortDirection={orderBy === 'amountWhenUsed' ? order : false}
          >
            <TableSortLabel
              active={orderBy === 'amountWhenUsed'}
              direction={order}
              onClick={() => {
                onRequestSort('amountWhenUsed');
              }}
            >
              {isFukuoka ? '利用額' : 'ごち利用額'}
            </TableSortLabel>
          </TableCell>

          {isFullInfo && (
            <>
              {!isFukuoka && (
                <>
                  <TableCell
                    sortDirection={orderBy === 'shopName' ? order : false}
                  >
                    <TableSortLabel
                      active={orderBy === 'shopName'}
                      direction={order}
                      onClick={() => {
                        onRequestSort('shopName');
                      }}
                    >
                      寄付額
                    </TableSortLabel>
                  </TableCell>
                  <TableCell
                    sortDirection={orderBy === 'amountWhenBuy' ? order : false}
                  >
                    <TableSortLabel
                      active={orderBy === 'amountWhenBuy'}
                      direction={order}
                      onClick={() => {
                        onRequestSort('amountWhenBuy');
                      }}
                    >
                      期限切れごち額
                    </TableSortLabel>
                  </TableCell>
                </>
              )}
              <TableCell
                sortDirection={orderBy === 'amountWhenUsed' ? order : false}
              >
                <TableSortLabel
                  active={orderBy === 'amountWhenUsed'}
                  direction={order}
                  onClick={() => {
                    onRequestSort('amountWhenUsed');
                  }}
                >
                  {isFukuoka ? '利用者数' : 'ごち利用者数'}
                </TableSortLabel>
              </TableCell>
            </>
          )}
        </TableRow>
      </TableHead>
    );
  }
);

export default withStyles(styles)(GochiTableHead);
